// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","element":"Footer_element__-9oE-"};